<div class="calendar-month week">
  <app-calendar-header [firstOfWeek]="firstOfWeek" [lastOfWeek]="lastOfWeek" [focusDate]="focusDate" [loading]="loading"
    (jumpToDate)="jumpToDate($event)" (prev)="prevWeek()" (next)="nextWeek()"></app-calendar-header>

  <app-calendar-grid viewType="week" [events]="events" [focusDate]="focusDate"
    (dayWithEventsClicked)="openListEventsDialog($event)" (singleEventClicked)="viewSingleEvent($event)"></app-calendar-grid>
</div>
